/* Wynden Home: showcase sections for the games and décor range.
   [data-wh-play="ttt"]    a playable round of tic-tac-toe against the page, in gold or blue crystal
   [data-wh-play="glass"]  the two glass chess sets drawn to scale; dimension lines draw in when the section is seen
   [data-wh-play="fold"]   the folding chess box: felt and pieces, lift out, flip, pieces snap onto the board
   [data-wh-play="drawer"] the chess cabinet's drawer slides out as the section scrolls into view
   [data-wh-play="motif"]  a flower from the jewelry box lid paints itself in three steps; box sizes to scale pick a variant
   [data-wh-play="orbit"]  the desk globe: the sphere spins live (orthographic projection), tips over for "two axes", four numbered parts take turns
   [data-wh-play="anatomy"] the chef knife to scale: lengths draw in, five numbered parts take turns until one is tapped
   [data-wh-play="kettle"] the copper kettle fills to its capacity, cups or mugs count up; a slider darkens the inside
   [data-wh-play="why"]    «why this one»: reasons with arrows drawing towards two slanted photos
   [data-wh-play="stone"]  a stone bowl or fruit stand is cut again in travertine, white or black marble; the stone buttons pick a variant
  [data-wh-play="tabletop"] marble tic-tac-toe: both boards at real size on the chosen table top; a line says which stands out
   [data-wh-play="cairn"]  stone bookends at real size on a shelf: stones drop and settle; chips put books between them
   Scroll is listened to on the whole document in the capture phase (Horizon scrolls .page-wrapper on wide screens). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function onView(el, fn, margin) {
    if (!('IntersectionObserver' in window)) { fn(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting); }); }, { rootMargin: margin || '0px' }).observe(el);
  }

  /* ---------- tic-tac-toe ---------- */
  var LINES = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];
  var X_SVG = '<svg viewBox="0 0 100 100" aria-hidden="true"><defs><linearGradient id="IDg" x1="0" y1="0" x2="1" y2="1"><stop class="ttt-x1" offset="0"/><stop class="ttt-x2" offset="1"/></linearGradient></defs>' +
    '<g transform="rotate(45 50 50)"><rect x="40" y="6" width="20" height="88" rx="2" fill="url(#IDg)" opacity=".92"/><rect x="6" y="40" width="88" height="20" rx="2" fill="url(#IDg)" opacity=".92"/>' +
    '<rect x="43" y="9" width="4" height="82" fill="#fff" opacity=".45"/></g></svg>';
  var O_SVG = '<svg viewBox="0 0 100 100" aria-hidden="true"><defs><radialGradient id="IDr" cx=".42" cy=".38" r=".7"><stop class="ttt-o1" offset="0"/><stop class="ttt-o1" offset=".45"/><stop class="ttt-o2" offset="1"/></radialGradient></defs>' +
    '<circle cx="50" cy="50" r="40" fill="url(#IDr)" stroke="rgba(255,255,255,.95)" stroke-width="3"/><circle cx="50" cy="50" r="30" fill="none" stroke="rgba(255,255,255,.7)" stroke-width="1.5"/>' +
    '<path d="M28 34 A26 26 0 0 1 52 22" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round" opacity=".8"/></svg>';
  var uid = 0;
  function winner(b) {
    for (var i = 0; i < LINES.length; i++) { var l = LINES[i]; if (b[l[0]] && b[l[0]] === b[l[1]] && b[l[0]] === b[l[2]]) return { p: b[l[0]], line: l }; }
    return b.indexOf('') === -1 ? { p: 'draw', line: [] } : null;
  }
  function pick(b) {
    var free = []; b.forEach(function (v, i) { if (!v) free.push(i); });
    function finish(p) { for (var i = 0; i < free.length; i++) { var t = b.slice(); t[free[i]] = p; var w = winner(t); if (w && w.p === p) return free[i]; } return -1; }
    var m = finish('o'); if (m > -1) return m;
    m = finish('x'); if (m > -1 && Math.random() < 0.85) return m;   // a person can still win now and then
    if (!b[4] && Math.random() < 0.8) return 4;
    var corners = [0, 2, 6, 8].filter(function (i) { return !b[i]; });
    if (corners.length && Math.random() < 0.6) return corners[Math.floor(Math.random() * corners.length)];
    return free[Math.floor(Math.random() * free.length)];
  }
  function initTtt(root) {
    var box = root.querySelector('.ttt'), cells = all(root, '.ttt-c'), status = root.querySelector('.ttt-status');
    var again = root.querySelector('[data-again]'), over = root.querySelector('[data-over]'), overMsg = root.querySelector('[data-over-msg]'), you = root.querySelector('[data-you]'), them = root.querySelector('[data-them]');
    var T = root.dataset, b, busy, score = [0, 0], first = 'x';
    function draw(i, p) {
      var id = 'ttt' + (++uid);
      cells[i].innerHTML = (p === 'x' ? X_SVG : O_SVG).replace(/ID/g, id);
      cells[i].setAttribute('aria-label', cells[i].dataset.n + ': ' + (p === 'x' ? T.lX : T.lO));
      cells[i].disabled = true;
    }
    function end(w) {
      busy = true; cells.forEach(function (c) { c.disabled = true; });
      w.line.forEach(function (i) { cells[i].classList.add('win'); });
      if (w.p === 'x') { score[0]++; status.textContent = T.win; }
      else if (w.p === 'o') { score[1]++; status.textContent = T.lose; }
      else status.textContent = T.draw;
      overMsg.textContent = status.textContent;
      you.textContent = score[0]; them.textContent = score[1];
      setTimeout(function () { over.hidden = false; again.focus({ preventScroll: true }); }, reduce ? 0 : 900);   // let the winning line show first
    }
    function boardMove() {
      var i = pick(b); b[i] = 'o'; draw(i, 'o');
      var w = winner(b); if (w) return end(w);
      busy = false; status.textContent = T.turn;
      cells.forEach(function (c, k) { c.disabled = !!b[k]; });
    }
    function reset() {
      b = ['', '', '', '', '', '', '', '', '']; busy = false; over.hidden = true;
      cells.forEach(function (c) { c.innerHTML = ''; c.disabled = false; c.classList.remove('win'); c.setAttribute('aria-label', c.dataset.n + ': ' + T.empty); });
      status.textContent = T.turn;
      box.classList.add('is-fresh');
      if (first === 'o') { busy = true; status.textContent = T.thinking; setTimeout(boardMove, reduce ? 0 : 500); }
      first = first === 'x' ? 'o' : 'x';   // take turns at starting
    }
    cells.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (busy || b[i]) return;
        box.classList.remove('is-fresh');
        b[i] = 'x'; draw(i, 'x');
        var w = winner(b); if (w) return end(w);
        busy = true; cells.forEach(function (cc) { cc.disabled = true; }); status.textContent = T.thinking;
        setTimeout(boardMove, reduce ? 0 : 520);
      });
    });
    again.addEventListener('click', reset);
    var skins = all(root, '.pl-chip[data-skin]');
    skins.forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.setAttribute('data-skin', btn.getAttribute('data-skin'));
        skins.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
      });
    });
    reset();
  }

  /* ---------- glass chess: two sets to scale ---------- */
  function initGlass(root) {
    var gs = root.querySelector('.gs');
    if (reduce) gs.classList.add('is-in'); else onView(gs, function (v) { if (v) gs.classList.add('is-in'); }, '-15% 0px');
    all(root, '.gs-card[data-set]').forEach(function (c) {
      var k = c.getAttribute('data-set');
      c.addEventListener('mouseenter', function () { gs.classList.add('hl-' + k); });
      c.addEventListener('mouseleave', function () { gs.classList.remove('hl-' + k); });
    });
    all(root, '.gs-pick').forEach(function (b) {
      b.addEventListener('click', function () { pickVariant(b.getAttribute('data-variant')); });
    });
  }

  /* ---------- wooden chess: fold ---------- */
  function initFold(root) {
    var fd = root.querySelector('.fd'), steps = all(root, '.fd-steps li'), btn = root.querySelector('[data-fold]'), timers = [], played = false;
    var ORDER = ['felt', 'lift', 'board', 'set'];
    function show(st) { fd.setAttribute('data-st', st); var k = ORDER.indexOf(st); steps.forEach(function (s, i) { s.classList.toggle('on', i === Math.min(k, steps.length - 1)); }); }
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function setUp() {
      clear(); btn.textContent = btn.dataset.pack; btn.dataset.state = 'set';
      if (reduce) return show('set');
      show('felt'); timers.push(setTimeout(function () { show('lift'); }, 700), setTimeout(function () { show('board'); }, 1400), setTimeout(function () { show('set'); }, 2300));
    }
    function pack() { clear(); btn.textContent = btn.dataset.setup; btn.dataset.state = 'felt'; show('board'); timers.push(setTimeout(function () { show('felt'); }, reduce ? 0 : 500)); }
    btn.addEventListener('click', function () { if (btn.dataset.state === 'set') pack(); else setUp(); });
    var woods = all(root, '.pl-chip[data-wood]');
    woods.forEach(function (c) {
      c.addEventListener('click', function () {
        fd.setAttribute('data-wood', c.getAttribute('data-wood'));
        woods.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      });
    });
    show('felt');
    onView(fd, function (v) { if (v && !played) { played = true; setTimeout(setUp, 400); } }, '-20% 0px');
  }

  /* ---------- chess cabinet: drawer ---------- */
  function initDrawer(root) {
    var dw = root.querySelector('.dw');
    if (reduce) { dw.style.setProperty('--p', '1'); dw.style.setProperty('--m', '1'); return; }
    var upd = function () {
      var r = dw.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = Math.min(1, Math.max(0, (vh * 0.92 - r.top) / (vh * 0.6)));
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      dw.style.setProperty('--p', e.toFixed(3));
      dw.style.setProperty('--m', Math.min(1, Math.max(0, p * 1.6 - 0.6)).toFixed(3));
    };
    document.addEventListener('scroll', upd, { passive: true, capture: true }); window.addEventListener('resize', upd); upd();
  }

  /* the card / drawing picks that choice in the buy column (wh-rd-product radios) and brings it back into view */
  function pickVariant(id) {
    var r = document.querySelector('input[name="wh-vpick"][value="' + id + '"]');
    if (!r) return;
    r.click();
    (r.closest('label') || r).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }

  /* ---------- jewelry box: painted motif + sizes ---------- */
  function initMotif(root) {
    var mf = root.querySelector('.mf'), steps = all(root, '.mf-steps li'), strip = root.querySelector('.mf-strip'), timers = [], played = false;
    function show(n) { mf.setAttribute('data-st', n); steps.forEach(function (s, i) { s.classList.toggle('on', i === n - 1); }); }
    function paint() {
      timers.forEach(clearTimeout); timers = [];
      if (reduce) return show(3);
      show(0);
      timers.push(setTimeout(function () { show(1); }, 120), setTimeout(function () { show(2); }, 1700), setTimeout(function () { show(3); }, 2800));
    }
    root.querySelector('[data-repaint]').addEventListener('click', paint);
    show(0);
    onView(mf, function (v) { if (v && !played) { played = true; paint(); } }, '-20% 0px');
    if (reduce) strip.classList.add('is-in'); else onView(strip, function (v) { if (v) strip.classList.add('is-in'); }, '-10% 0px');
    var boxes = all(root, '[data-box]');
    function mark(k) { boxes.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-box') === k); }); }
    boxes.forEach(function (b) {
      var k = b.getAttribute('data-box');
      b.addEventListener('mouseenter', function () { mark(k); });
      b.addEventListener('mouseleave', function () { mark(''); });
    });
    all(root, '.mf-box[data-variant], .mf-pick').forEach(function (b) {
      b.addEventListener('click', function () { pickVariant(b.getAttribute('data-variant')); });
    });
  }

  /* ---------- chef knife: anatomy ---------- */
  function initAnatomy(root) {
    var an = root.querySelector('.an'), dots = all(root, '.an-dot'), items = all(root, '.an-item'), keys = items.map(function (b) { return b.getAttribute('data-part'); });
    var k = -1, timer = 0, auto = true;
    function show(i) {
      k = i;
      dots.forEach(function (d) { d.classList.toggle('on', d.getAttribute('data-part') === keys[i]); });
      items.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    }
    function tick() { if (auto) { show((k + 1) % keys.length); timer = setTimeout(tick, 3200); } }
    function pick(key) { auto = false; clearTimeout(timer); show(keys.indexOf(key)); }
    items.forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-part')); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { pick(d.getAttribute('data-part')); }); });
    if (reduce) { an.classList.add('is-in'); show(0); return; }
    onView(an, function (v) { if (v && !an.classList.contains('is-in')) { an.classList.add('is-in'); timer = setTimeout(tick, 2200); } }, '-20% 0px');
  }

  /* ---------- desk globe: live spinning sphere ---------- */
  function initOrbit(root) {
    var gl = root.querySelector('.gl'), svg = gl.querySelector('svg');
    var land = JSON.parse(svg.getAttribute('data-land')), cc = svg.getAttribute('data-c').split(' ').map(Number), tilt = parseFloat(svg.getAttribute('data-tilt')) * Math.PI / 180;
    var NS = 'http://www.w3.org/2000/svg', D = Math.PI / 180, cx = cc[0], cy = cc[1], R = cc[2];
    var landG = svg.querySelector('.gl-land'), gridG = svg.querySelector('.gl-grid');
    var polys = land.map(function (a) {          /* densify: a point every <= 6 degrees */
      var out = [], n = a.length / 2;
      for (var i = 0; i < n; i++) {
        var p = [a[2 * i], a[2 * i + 1]], q = [a[2 * ((i + 1) % n)], a[2 * ((i + 1) % n) + 1]], k = Math.max(1, Math.ceil(Math.max(Math.abs(q[0] - p[0]), Math.abs(q[1] - p[1])) / 6));
        for (var j = 0; j < k; j++) out.push([p[0] + (q[0] - p[0]) * j / k, p[1] + (q[1] - p[1]) * j / k]);
      }
      return out;
    });
    var landP = polys.map(function () { var p = document.createElementNS(NS, 'path'); p.setAttribute('class', 'gl-cont'); landG.appendChild(p); return p; });
    var lines = [], k2, la;
    for (k2 = -180; k2 < 180; k2 += 30) { var m = []; for (la = -90; la <= 90; la += 6) m.push([k2, la]); lines.push(m); }
    for (la = -60; la <= 60; la += 30) { var pa = []; for (k2 = -180; k2 <= 180; k2 += 6) pa.push([k2, la]); lines.push(pa); }
    var gridP = lines.map(function () { var p = document.createElementNS(NS, 'path'); p.setAttribute('class', 'gl-meridian'); gridG.appendChild(p); return p; });
    var spin = 50 * D, tip = 0, tipTarget = 0, speed = 10, speedTarget = 10, axesOn = false;
    function proj(lon, lat) {                    /* spin about the polar axis, tip about the horizontal axis, tilt in the ring */
      var l = lon * D + spin, f = lat * D, x = Math.cos(f) * Math.sin(l), y = Math.sin(f), z = Math.cos(f) * Math.cos(l);
      var y1 = y * Math.cos(tip) - z * Math.sin(tip), z1 = y * Math.sin(tip) + z * Math.cos(tip);
      return [x * Math.cos(tilt) - y1 * Math.sin(tilt), x * Math.sin(tilt) + y1 * Math.cos(tilt), z1];
    }
    function sc(p) { return (cx + R * p[0]).toFixed(1) + ' ' + (cy - R * p[1]).toFixed(1); }
    function draw() {
      polys.forEach(function (poly, i) {
        var d = '', front = 0;
        poly.forEach(function (c, j) {
          var p = proj(c[0], c[1]);
          if (p[2] >= 0) front++; else { var h = Math.hypot(p[0], p[1]) || 1; p = [p[0] / h, p[1] / h, 0]; }
          d += (j ? 'L' : 'M') + sc(p);
        });
        landP[i].setAttribute('d', front ? d + 'Z' : '');
      });
      lines.forEach(function (ln, i) {
        var d = '', pen = false;
        ln.forEach(function (c) {
          var p = proj(c[0], c[1]);
          if (p[2] >= 0) { d += (pen ? 'L' : 'M') + sc(p); pen = true; } else pen = false;
        });
        gridP[i].setAttribute('d', d);
      });
    }
    /* four numbered parts take turns until one is tapped */
    var dots = all(root, '.gl-dot'), items = all(root, '.gl-item'), keys = items.map(function (b) { return b.getAttribute('data-part'); });
    var k = -1, timer = 0, auto = true;
    function show(i) {
      k = i; var key = keys[i];
      gl.setAttribute('data-gl', key);
      dots.forEach(function (d) { d.classList.toggle('on', d.getAttribute('data-part') === key); });
      items.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      axesOn = key === 'axes'; speedTarget = key === 'map' ? 4 : 10;
    }
    function tick() { if (auto) { show((k + 1) % keys.length); timer = setTimeout(tick, keys[k] === 'axes' ? 6000 : 3600); } }
    function pickKey(key) { auto = false; clearTimeout(timer); show(keys.indexOf(key)); }
    items.forEach(function (b) { b.addEventListener('click', function () { pickKey(b.getAttribute('data-part')); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { pickKey(d.getAttribute('data-part')); }); });
    draw();
    if (reduce) { gl.classList.add('is-in'); show(0); return; }
    var raf = 0, last = 0, t0 = 0;
    function frame(t) {
      if (!last) { last = t; t0 = t; }
      var dt = Math.min(0.05, (t - last) / 1000); last = t;
      speed += (speedTarget - speed) * Math.min(1, dt * 3);
      spin -= speed * D * dt;
      tipTarget = axesOn ? 52 * D * Math.sin((t - t0) / 1000 * 1.1) : 0;
      tip += (tipTarget - tip) * Math.min(1, dt * (axesOn ? 4 : 2.5));
      draw(); raf = requestAnimationFrame(frame);
    }
    onView(gl, function (v) {
      if (v) { if (!gl.classList.contains('is-in')) { gl.classList.add('is-in'); timer = setTimeout(tick, 2200); } if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
      else if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }, '-10% 0px');
  }

  /* ---------- copper kettle: fill and patina ---------- */
  function initKettle(root) {
    var kt = root.querySelector('.kt'), water = root.querySelector('.kt-water'), now = root.querySelector('[data-ml-now]');
    var row = root.querySelector('[data-cups]'), note = root.querySelector('[data-cupnote]'), chips = all(root, '.pl-chip[data-cup]');
    var total = +root.getAttribute('data-ml') || 1500, about = root.getAttribute('data-about') || '', f = 0, cup = chips[0];
    function cups() {
      var size = +cup.getAttribute('data-cup'), n = Math.round(total / size), lit = Math.floor(total * f / size + 1e-6), mug = size > 200;
      if (row.children.length !== n || row.getAttribute('data-size') !== String(size)) {
        row.innerHTML = ''; row.setAttribute('data-size', size);
        for (var i = 0; i < n; i++) { var c = document.createElement('i'); if (mug) c.className = 'mug'; row.appendChild(c); }
      }
      all(row, 'i').forEach(function (c, i) { c.classList.toggle('on', i < lit); });
      note.textContent = about + ' ' + n + ' ' + cup.getAttribute('data-word');
    }
    function paint() { water.style.setProperty('--f', f.toFixed(3)); now.textContent = Math.round(total * f / 10) * 10; cups(); }
    chips.forEach(function (b) {
      b.addEventListener('click', function () { cup = b; chips.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); cups(); });
    });
    var range = root.querySelector('[data-patina]'), dish = root.querySelector('[data-dish]');
    function dark() { dish.style.setProperty('--p', range.value); }
    range.addEventListener('input', dark); dark();
    function fill() {
      kt.classList.add('is-in');
      if (reduce) { f = 1; paint(); return; }
      var t0 = 0;
      requestAnimationFrame(function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 2600); f = 1 - Math.pow(1 - p, 3); paint(); if (p < 1) requestAnimationFrame(step); });
    }
    paint();
    onView(kt, function (v) { if (v && !kt.classList.contains('is-in')) fill(); }, '-20% 0px');
  }

  /* ---------- stone bowl: a new cut of travertine or black marble ---------- */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function el(tag, attrs) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
  function vein(x, y, ang, len, steps) {   /* a wandering line, the way a marble vein runs */
    var d = 'M' + x.toFixed(1) + ' ' + y.toFixed(1), seg = len / steps;
    for (var i = 0; i < steps; i++) { ang += rnd(-0.45, 0.45); x += Math.cos(ang) * seg; y += Math.sin(ang) * seg; d += ' L' + x.toFixed(1) + ' ' + y.toFixed(1); }
    return { d: d, x: x, y: y, ang: ang };
  }
  function cutMarble(g) {
    var n = Math.round(rnd(4, 7)), out = [];
    for (var i = 0; i < n; i++) {
      var left = Math.random() < 0.5, v = vein(left ? rnd(20, 120) : rnd(240, 340), rnd(70, 240), left ? rnd(0.2, 0.9) : rnd(2.2, 2.9), rnd(260, 420), 26);
      out.push({ d: v.d, w: rnd(0.7, 2.4), o: rnd(0.45, 0.95) });
      if (Math.random() < 0.7) { var b = vein(v.x * 0.5 + 90, v.y * 0.5 + 60, v.ang + rnd(-1.2, 1.2), rnd(60, 160), 10); out.push({ d: b.d, w: rnd(0.4, 1), o: rnd(0.35, 0.7) }); }
    }
    out.forEach(function (p, i) {
      var e = el('path', { d: p.d, class: 'st-vein', 'stroke-width': p.w.toFixed(2), opacity: p.o.toFixed(2), pathLength: 1 });
      e.style.setProperty('--d', (i * 0.12).toFixed(2) + 's'); g.appendChild(e);
    });
  }
  function cutTravertine(g) {
    var y = 40, i = 0;
    while (y < 410) {   /* layered bands, a little wavy, lighter and darker */
      var amp = rnd(1.5, 6), d = 'M-10 ' + y.toFixed(1), k = rnd(0, 6);
      for (var x = 20; x <= 370; x += 30) d += ' Q' + (x - 15) + ' ' + (y + Math.sin(k + x / 47) * amp).toFixed(1) + ' ' + x + ' ' + (y + Math.sin(k + x / 31) * amp * 0.6).toFixed(1);
      var e = el('path', { d: d, class: 'st-band' + (Math.random() < 0.45 ? ' st-band--dk' : ''), 'stroke-width': rnd(1, 7).toFixed(1), opacity: rnd(0.25, 0.7).toFixed(2) });
      e.style.setProperty('--d', (i++ * 0.05).toFixed(2) + 's'); g.appendChild(e);
      y += rnd(7, 22);
    }
    for (var p = 0; p < 70; p++) {   /* open pores, stretched along the bands */
      var r = rnd(0.8, 4), c = el('ellipse', { cx: rnd(50, 310).toFixed(1), cy: rnd(95, 395).toFixed(1), rx: (r * rnd(1.4, 3)).toFixed(1), ry: (r * 0.5).toFixed(1), class: 'st-pore' });
      c.style.setProperty('--d', (0.4 + Math.random() * 0.9).toFixed(2) + 's'); g.appendChild(c);
    }
  }
  function initStone(root) {
    var st = root.querySelector('.st'), stones = all(root, '.st-stone'), shown = false;
    function cut() {
      var g = st.querySelector('.st-shape[data-shape="' + st.getAttribute('data-shape') + '"] [data-veins]') || st.querySelector('[data-veins]');
      all(st, '[data-veins]').forEach(function (v) { v.innerHTML = ''; });
      if (st.getAttribute('data-stone') === 'trav') cutTravertine(g); else cutMarble(g);
      st.classList.remove('is-cut'); void st.getBoundingClientRect(); st.classList.add('is-cut');
    }
    function pick(b) { st.setAttribute('data-stone', b.getAttribute('data-to')); if (b.getAttribute('data-shape')) st.setAttribute('data-shape', b.getAttribute('data-shape')); stones.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); cut(); }
    stones.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var again = root.querySelector('[data-again]'); if (again) again.addEventListener('click', cut);
    root.querySelector('[data-pick]').addEventListener('click', function () {
      var on = stones.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      if (on && on.getAttribute('data-variant')) pickVariant(on.getAttribute('data-variant'));
    });
    if (reduce) { cut(); return; }
    onView(st, function (v) { if (v && !shown) { shown = true; cut(); } }, '-20% 0px');
  }


  /* ---------- marble tic-tac-toe: match it to your table ---------- */
  function initTabletop(root) {
    var tt = root.querySelector('.tt'), say = root.querySelector('.tt-say'), chips = all(root, '.tt-chip'), lift;
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-pressed') === 'true') return;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        tt.setAttribute('data-surface', b.getAttribute('data-to'));
        tt.classList.add('is-lift'); clearTimeout(lift); lift = setTimeout(function () { tt.classList.remove('is-lift'); }, 260);
        say.classList.add('is-out');
        setTimeout(function () { say.textContent = b.getAttribute('data-say'); say.classList.remove('is-out'); }, reduce ? 0 : 220);
      });
    });
    all(root, '.tt-pick').forEach(function (b) { b.addEventListener('click', function () { pickVariant(b.getAttribute('data-variant')); }); });
    if (reduce) { tt.classList.add('is-in'); return; }
    onView(tt, function (v) { if (v) tt.classList.add('is-in'); }, '-15% 0px');
  }

  /* ---------- stone bookends: stones drop onto their bases, chips change the row of books ---------- */
  function initCairn(root) {
    var cb = root.querySelector('.cb'), say = root.querySelector('.cb-say'), chips = all(root, '.cb-chip');
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-pressed') === 'true') return;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        cb.classList.remove('is-first'); cb.setAttribute('data-row', b.getAttribute('data-to'));
        say.classList.add('is-out');
        setTimeout(function () { say.textContent = b.getAttribute('data-say'); say.classList.remove('is-out'); }, reduce ? 0 : 220);
      });
    });
    if (reduce) { cb.classList.add('is-in'); return; }
    cb.classList.add('is-first');
    onView(cb, function (v) { if (v) cb.classList.add('is-in'); }, '-15% 0px');
  }

  /* ---------- incense burner: shape, lid and lid on / off; smoke starts when in view ---------- */
  function initSmoke(root) {
    var sm = root.querySelector('.sm'), say = root.querySelector('.sm-say');
    all(root, '.pl-chip[data-k]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-k');
        if (b.getAttribute('aria-pressed') === 'true') return;
        all(root, '.pl-chip[data-k="' + k + '"]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        sm.setAttribute('data-' + k, b.getAttribute('data-v'));
        if (k === 'cover') {
          say.classList.add('is-out');
          setTimeout(function () { say.textContent = b.getAttribute('data-say'); say.classList.remove('is-out'); }, reduce ? 0 : 220);
        }
      });
    });
    if (reduce) { sm.classList.add('is-in'); return; }
    onView(sm, function (v) { if (v) sm.classList.add('is-in'); }, '-10% 0px');
  }

  /* ---------- why this one: reasons rise in and their arrows draw towards the photos ---------- */
  function initWhy(root) {
    // dots look: hovering or focusing a reason lights its dot on the photo
    all(root, '.wyh-list li').forEach(function (li) {
      var k = li.getAttribute('data-spot'), dot = root.querySelector('.wyh-dot[data-spot="' + k + '"]');
      function on(v) { li.classList.toggle('on', v); if (dot) dot.classList.toggle('on', v); }
      li.addEventListener('mouseenter', function () { on(true); }); li.addEventListener('mouseleave', function () { on(false); });
      li.addEventListener('focus', function () { on(true); }); li.addEventListener('blur', function () { on(false); });
    });
    // material switch: each row shows yes / no / depends for the chosen column
    var sw = root.querySelector('[data-sw]');
    if (sw) {
      var tabs = all(sw, '[data-col]'), rowsEl = all(sw, '[data-marks]');
      var show = function (col) {
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-col') === String(col) ? 'true' : 'false'); });
        rowsEl.forEach(function (r) {
          var m = (r.getAttribute('data-marks').split(/\s+/)[col] || '-'), k = m === 'y' ? 'y' : m === 'n' ? 'n' : 'na', mk = r.querySelector('[data-mark]');
          mk.className = 'wy-m wy-m--' + k; r.classList.toggle('is-no', k === 'n'); r.classList.toggle('is-na', k === 'na');
        });
      };
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-col')); }); });
      show(0);
    }
    // question cards turn over on click / Enter (hover turns them on desktop through CSS)
    all(root, '.wyf-card').forEach(function (b) {
      b.addEventListener('click', function () { var on = !b.classList.contains('is-flipped'); b.classList.toggle('is-flipped', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    });
    // big figures count up from zero, keeping whatever text sits around the number
    var counts = all(root, '[data-count]');
    function countUp() {
      counts.forEach(function (el, i) {
        var t = el.textContent, m = t.match(/[0-9][0-9,.]*/);
        if (!m) return;
        var raw = m[0], end = parseFloat(raw.replace(/,/g, '')), dec = (raw.split('.')[1] || '').length, t0 = null, dur = 1400;
        if (!isFinite(end)) return;
        function step(ts) {
          if (t0 === null) t0 = ts + i * 140;
          var k = Math.min(1, Math.max(0, (ts - t0) / dur)), e = 1 - Math.pow(1 - k, 3), v = (end * e).toFixed(dec);
          if (raw.indexOf(',') > -1) v = Number(v).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
          el.textContent = t.replace(raw, v);
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
    if (reduce) { root.classList.add('is-in'); return; }
    var counted = false;
    onView(root, function (v) { if (v) { root.classList.add('is-in'); if (!counted) { counted = true; countUp(); } } }, '-15% 0px');
  }

  function init(scope) {
    all(scope, '[data-wh-play]').forEach(function (root) {
      if (root.dataset.whPlayOn) return; root.dataset.whPlayOn = '1';
      var k = root.getAttribute('data-wh-play');
      if (k === 'ttt') initTtt(root); else if (k === 'glass') initGlass(root); else if (k === 'fold') initFold(root); else if (k === 'drawer') initDrawer(root); else if (k === 'motif') initMotif(root); else if (k === 'anatomy') initAnatomy(root); else if (k === 'orbit') initOrbit(root); else if (k === 'kettle') initKettle(root); else if (k === 'stone') initStone(root); else if (k === 'tabletop') initTabletop(root); else if (k === 'cairn') initCairn(root); else if (k === 'smoke') initSmoke(root); else if (k === 'why') initWhy(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
